import React from 'react';
import { Activity, Wheat, ShieldPlus, Flower2, Sprout, Droplet, Carrot } from 'lucide-react';
const ingredients = [{
  icon: Activity,
  title: 'Darmzotten',
  desc: 'Optimiert die Nährstoffaufnahme im Darm'
}, {
  icon: Wheat,
  title: 'Ballaststoffe',
  desc: 'Verbessern Darmpassage und Nährstoffverwertung'
}, {
  icon: ShieldPlus,
  title: 'Präbiotika',
  desc: 'Gesunde Darmflora = bessere Absorption'
}, {
  icon: Flower2,
  title: 'Artischocke',
  desc: 'Aktiviert wichtige Verdauungsenzyme'
}, {
  icon: Sprout,
  title: 'Mariendistel',
  desc: 'Unterstützt die Leber bei der Nährstoffverarbeitung'
}, {
  icon: Droplet,
  title: 'Leinsamen',
  desc: 'Bildet schützende Darmwandschicht für bessere Aufnahme'
}, {
  icon: Carrot,
  title: 'Möhrenmehl',
  desc: 'Liefert Beta-Carotin, das zu Vitamin A wird'
}];
export function ProductExplanation() {
  return <section className="py-12 px-4 bg-forest/5 rounded-3xl mb-12 border border-forest/10" data-id="element-109">
      <h3 className="font-handwriting text-3xl md:text-4xl font-bold text-forest text-center mb-8" data-id="element-110">
        Warum manche Hunde Nährstoffe nicht richtig verwerten
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8" data-id="element-111">
        {ingredients.map((item, index) => <div key={index} className="flex items-start gap-4 bg-card p-4 rounded-xl shadow-sm" data-id="element-112">
            <div className="bg-cream p-2 rounded-lg text-brown shrink-0" data-id="element-113">
              <item.icon size={24} data-id="element-114" />
            </div>
            <div data-id="element-115">
              <h4 className="font-serif font-bold text-forest text-lg mb-1" data-id="element-116">
                {item.title}
              </h4>
              <p className="font-serif text-sm text-text/80 leading-snug" data-id="element-117">
                {item.desc}
              </p>
            </div>
          </div>)}
      </div>

      <div className="text-center" data-id="element-118">
        <span className="inline-block bg-forest text-cream font-serif text-sm px-4 py-1.5 rounded-full font-medium" data-id="element-119">
          100% pflanzlich, keine künstlichen Zusätze
        </span>
      </div>
    </section>;
}